module.exports = __webpack_public_path__ + "static/media/iconPricing.2b50126d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/iconPricing.svg
// module id = 439
// module chunks = 0